import { createLucideIcon } from "lucide-react";

const IconMegaphone = createLucideIcon("megaphone-classic", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "megaphone-cone" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "megaphone-handle" }],
]);

export default IconMegaphone;
